import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
  import { useStore } from 'vuex';
  import { User, Utils } from 'types';
  import FPLogo from './Logo/FPLogo.vue';
  import MCFPLogo from './Logo/MCxFPLogo.vue';
  import AnnaLogoBoxed from './Logo/AnnaBoxed.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LogoComputed',
  setup(__props) {

  const store = useStore();

  const userCategory = computed<User.UserCategory.Category>(
    () => store.state.user.category,
  );

  const cobrand = computed<Utils.Cobrand.Params>(
    () => store.state.support.cobrand,
  );

  const Logo = computed(() => {
    if (cobrand.value === Utils.Cobrand.Params.Anna) {
      return AnnaLogoBoxed;
    }

    if (
      [
        User.UserCategory.Category.Individual,
        User.UserCategory.Category.Personal,
      ].includes(userCategory.value) ||
      cobrand.value === Utils.Cobrand.Params.None
    ) {
      return FPLogo;
    }

    return MCFPLogo;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(Logo))))
}
}

})